import { ListItem, NumberedList, Link } from '@entur/typography';
import "../../../../../pages/sales/guides.scss";
import * as React from 'react';
export default {
  ListItem,
  NumberedList,
  Link,
  React
};